import {
  IconUser,
  IconFileText,
  IconSettings,
  IconShoppingCart
} from '@tabler/icons-react';

/**
 * Customer Navigation Menu
 * 
 * Customers have limited access:
 * - View their own subscriptions
 * - Place orders (new subscriptions or renewals)
 * - Manage profile and settings
 * 
 * No access to:
 * - Dashboard/Analytics
 * - Management features
 * - Campaigns
 * - Credits
 * - Other users' data
 */
const customer = {
  id: 'customer',
  title: 'Customer',
  type: 'group' as const,
  children: [
    {
      id: 'subscriptions',
      title: 'My Subscriptions',
      type: 'item',
      url: '/subscriptions',
      icon: IconFileText,
      breadcrumbs: false
    },
    {
      id: 'orders',
      title: 'Orders',
      type: 'item',
      url: '/orders',
      icon: IconShoppingCart,
      breadcrumbs: false
    },
    {
      id: 'profile',
      title: 'Profile',
      type: 'item',
      url: '/profile',
      icon: IconUser,
      breadcrumbs: false
    },
    {
      id: 'settings',
      title: 'Settings',
      type: 'item',
      url: '/settings',
      icon: IconSettings,
      breadcrumbs: false
    }
  ]
};

export default customer;
